export const API_URL = process.env.VUE_APP_API_URL || 'https://cqe-api-int.k8s-v2.satoripop.io';
export const x_api_key = process.env.VUE_APP_X_API_KEY || 'oAp4Ovaov86BOQLw1Ma8KqjErj4brfJa';
export default API_URL;
export const PAYMENT_URL = process.env.VUE_APP_PAYMENT_URL || 'http://cqe-bo-int.k8s-v2.satoripop.io/payment';
export const MAIL_SUPPORT = process.env.VUE_APP_MAIL_SUPPORT ||  'support@cqe.tn';